import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieAcceptModalComponent } from './cookie-accept-modal/cookie-accept-modal.component';
import { CookieSettingsModalComponent } from './cookie-settings-modal/cookie-settings-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AcceptPrivacyPolicyAndTermsComponent } from './accept-privacy-policy-and-terms/accept-privacy-policy-and-terms.component';
import { AcceptPrivacyPolicyModalComponent } from './accept-privacy-policy-modal/accept-privacy-policy-modal.component';



@NgModule({
  declarations: [CookieAcceptModalComponent, CookieSettingsModalComponent, AcceptPrivacyPolicyAndTermsComponent, AcceptPrivacyPolicyModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule
  ],
  exports:[CookieAcceptModalComponent,CookieSettingsModalComponent,AcceptPrivacyPolicyAndTermsComponent]
})
export class CookieSettingsModule { }
